'use strict';
var React = require('react');

var UX2017Work = React.createClass({
  getInitialState: function () {
    return {
      showAd: true
    }
  },
  render: function () {
    var style = {
      display: this.state.showAd ? 'block' : 'none'
    };
    return (
      <div className='ux2017-work' style={style}>
        <div onClick={this.onClose} className="close"></div>
        <p>这个原型正在参加Mockplus原型设计大赛。</p>
        <p>参赛可赢取 iPhone 8！</p>
        <p>了解大赛详情，<a href="https://www.mockplus.cn/ux2017">请猛戳这里&gt;&gt;</a></p>
      </div>
    );
  },
  onClose: function () {
    this.setState({
      showAd: false
    });
  }
});

module.exports = UX2017Work;



// WEBPACK FOOTER //
// ./src/views/UX2017Work.jsx